import { render } from "./CustomPageNone.vue?vue&type=template&id=4c4d4081"
import script from "./CustomPageNone.vue?vue&type=script&lang=js"
export * from "./CustomPageNone.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__